import alt from "../alt";
import indexBy from "lodash/keyBy";
import values from "lodash/values";
import EventBucketActions from "../actions/EventBucketActions";
import PassBucketUtil from "../utils/PassBucketUtil";
import PassBucketActions from "../actions/PassBucketActions";
import UserStore from "../stores/UserStore";

class PassBucketStore {
  constructor() {
    this.bindActions(PassBucketActions);

    this.state = {
      passBuckets: {},
      newPassBucketId: null,
      isFetching: false
    };

    this.exportPublicMethods({
      getPassBucketById: this.getPassBucketById.bind(this),
      getPassBucketsForEventBucket: this.getPassBucketsForEventBucket.bind(
        this
      ),
      getAllPassBuckets: this.getAllPassBuckets.bind(this)
    });
  }

  getPassBucketById(id) {
    return this.state.passBuckets[id];
  }

  getPassBucketsForEventBucket(id) {
    return values(this.state.passBuckets).filter(function (p) {
      return p.event_bucket === id;
    });
  }

  getAllPassBuckets() {
    const bucketIds = Object.keys(this.state.passBuckets);
    const allPassBuckets = bucketIds.map(id => {
      return this.state.passBuckets[id];
    });
    return allPassBuckets;
  }

  onFetchAllForEventBucket(eventBucket) {
    this.setState({ isFetching: true });
    PassBucketUtil.fetchAllForEventBucket(
      UserStore.getState().apiKey,
      eventBucket
    )
      .then(data => {
        PassBucketActions.updatePassBuckets(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(PassBucketActions.fetchFailed);
  }

  onFetchAll() {
    this.setState({ isFetching: true });
    PassBucketUtil.fetchAll(UserStore.getState().apiKey)
      .then(data => {
        PassBucketActions.updatePassBuckets(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(PassBucketActions.fetchFailed);
  }

  onFetchOne(id) {
    PassBucketUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        PassBucketActions.updatePassBucket(id, data);
      })
      .catch(PassBucketActions.fetchFailed);
  }

  onEdit(newData) {
    PassBucketUtil.edit(UserStore.getState().apiKey, newData.id, newData.values)
      .then(data => {
        window.Intercom("trackEvent", "edit-pass-bucket");

        PassBucketActions.updatePassBucket(newData.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
      })
      .catch(PassBucketActions.editFailed);
  }

  onDelete(id) {
    PassBucketUtil.delete(UserStore.getState().apiKey, id)
      .then(data => {
        EventBucketActions.fetchOne(this.state.passBuckets[id].event_bucket);
        PassBucketActions.updatePassBucket(id, undefined);
      })
      .catch(PassBucketActions.editFailed);
  }

  onCreate(newData) {
    this.setState({
      newPassBucketId: null
    });

    PassBucketUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        PassBucketActions.updatePassBucket(data.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
        this.setState({
          newPassBucketId: data.id
        });
      })
      .catch(PassBucketActions.editFailed);
  }

  onDuplicate(id) {
    this.setState({
      newPassBucketId: null
    });

    PassBucketUtil.duplicate(UserStore.getState().apiKey, id)
      .then(data => {
        PassBucketActions.updatePassBucket(data.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
        this.setState({
          newPassBucketId: data.id
        });
      })
      .catch(PassBucketActions.editFailed);
  }

  onUpdatePassBuckets(passBuckets) {
    let newBuckets = Object.assign({}, this.state.passBuckets, passBuckets);
    this.setState({ passBuckets: newBuckets });
  }

  onUpdatePassBucket(data) {
    if (!data.passBucket) {
      delete this.state.passBuckets[data.id];
    } else {
      this.state.passBuckets[data.id] = data.passBucket;
    }
    this.state.newPassBucketId = null;
    this.setState(this.state);
  }

  onFetchFailed(e) {
    alert(`Fetching pass bucket failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    alert(`Edit failed: ${e.message}`);
  }
}

export default alt.createStore(PassBucketStore, "PassBucketStore");



// WEBPACK FOOTER //
// ./src/app/stores/PassBucketStore.js